import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MonitorTaskService } from '../../../services/monitor-task.service';

@Component({
  selector: 'app-price-monitoring-task-logs',
  standalone: false,
  templateUrl: './price-monitoring-task-logs.component.html'
})
export class PriceMonitoringTaskLogsComponent implements OnInit {
  dataLoading = false
  @Input() recordId!: number;
  @Output() close = new EventEmitter<boolean>();
  recordsData: any[] = [];

  constructor(
    private service: MonitorTaskService
  ) { }

  ngOnInit(): void {
    this.getDetails();
  }

  getDetails() {
    this.dataLoading = true
    this.service.getTaskLogs(this.recordId).subscribe((data) => {
      this.recordsData = data as any[];
      this.dataLoading = false
    }, (error: any) => {

    })
  }

}
